"use client";

import { MotionConfig } from "framer-motion";
import { stegaClean } from "@sanity/client/stega";
import { cn } from "@/lib/utils";
import type { PageEventSchema } from "@/sanity/pages/PageEventTemplate";
import { EventHost } from "@/components/pageComponents/event/EventHost";
import { EventFaq } from "@/components/pageComponents/event/EventFaq";
import { EventFinalCta } from "@/components/pageComponents/event/EventFinalCta";
import ScrollingBanner from "@/components/pageComponents/global/ScrollingBanner";
import { MonthlyUpdateHero } from "@/components/pageComponents/monthly-update/MonthlyUpdateHero";
import { MonthlyUpdateContents } from "@/components/pageComponents/monthly-update/MonthlyUpdateContents";
import { monthlyUpdateDefaults } from "@/components/pageComponents/monthly-update/content";
import styles from "@/components/pageComponents/monthly-update/monthly-update.module.css";

export default function PageMonthlyUpdateJSX({ data }: { data: PageEventSchema }) {
  const content: PageEventSchema = { settings: data.settings, ...monthlyUpdateDefaults, ...Object.fromEntries(Object.entries(data).filter(([, value]) => value != null)) };
  content.features = content.features?.map((item, i) => ({ ...item, icon: item.icon?.src ? item.icon : monthlyUpdateDefaults.features.find(defaultItem => defaultItem._key === item._key)?.icon ?? monthlyUpdateDefaults.features[i]?.icon }));
  content.s4Items = content.s4Items?.map((item, i) => ({ ...item, icon: item.icon?.src ? item.icon : monthlyUpdateDefaults.s4Items.find(defaultItem => defaultItem._key === item._key)?.icon ?? monthlyUpdateDefaults.s4Items[i]?.icon }));
  const cta = data.cta ?? monthlyUpdateDefaults.cta;
  const shared = { ...content, cta, s4Cta: data.s4Cta ?? cta, s6Cta: data.s6Cta ?? cta };
  const banner = <ScrollingBanner variant="serif" className="border-y-0 max-lg:h-[calc(6.25*var(--page-rem))]" words={content.scrollingWords?.words} wordsI18n={content.scrollingWords?.wordsI18n} language={content.settings.language} />;

  return (
    <MotionConfig reducedMotion="user">
      <div className={cn(styles.page, "relative w-full bg-[#fbfbfb] [text-wrap:wrap] selection:bg-[#296e5a] selection:text-white [&_:focus-visible]:outline [&_:focus-visible]:outline-2 [&_:focus-visible]:outline-[#219653] [&_:focus-visible]:outline-offset-2")}>
        <MonthlyUpdateHero data={shared} />
        {banner}
        <MonthlyUpdateContents data={shared} />
        <EventHost data={shared} layout="monthly" mobileImageSrc={stegaClean(shared.s4Image?.src ?? "") === monthlyUpdateDefaults.s4Image.src ? "/monthly-update/mobile-host-portrait.png" : undefined} />
        <EventFaq data={shared} initialOpen={0} layout="monthly" />
        {banner}
        <EventFinalCta data={shared} layout="monthly" />
      </div>
    </MotionConfig>
  );
}
